module.exports = __webpack_public_path__ + "static/media/electricity_1.3a61b84b.png";